import { FC } from "react";
import { useTranslation } from "react-i18next";

import Desktop from "../../../../assets/images/content/pillar-2/large-appliances-sold-globally/large-appliances-sold-globally-desktop.svg";
import Mobile from "../../../../assets/images/content/pillar-2/large-appliances-sold-globally/large-appliances-sold-globally-mobile.svg";

const LargeAppliancesSoldGlobally: FC = () => {
	const { t } = useTranslation();

	return (
		<div className="flex flex-col items-center justify-center">
			<img
				className="hidden sm:block w-full max-w-3xl"
				src={Desktop}
				alt={t("pages.pillar.pillar2.largeAppliancesSoldGlobally.blocks.visual.alt") as string}
				title={t("pages.pillar.pillar2.largeAppliancesSoldGlobally.blocks.visual.alt") as string}
			/>
			<img
				className="block sm:hidden"
				src={Mobile}
				alt={t("pages.pillar.pillar2.largeAppliancesSoldGlobally.blocks.visual.alt") as string}
				title={t("pages.pillar.pillar2.largeAppliancesSoldGlobally.blocks.visual.alt") as string}
			/>
		</div>
	);
};

export { LargeAppliancesSoldGlobally };
